import { css } from '@emotion/core';

export const root = css`
  background-color: transparent;
  border: none;
  cursor: pointer;

  transition: all 250ms ease-in-out;
  will-change: opacity;
  opacity: 0.4;

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: 0;
  }
`;
